<mat-drawer-container [hasBackdrop]=true>
  <mat-drawer class="lv-drawer" #drawer position="end">
    <ng-container *ngIf="fondsData$ | async">
      <div class="lv-dialog-header lv-drawer-header lv-sticky">
        <div class="lv-dialog-header-title">
          Filter
        </div>
        <div class="lv-dialog-header-close-icon">
          <mat-icon [svgIcon]="'Times'" (click)="drawer.toggle()"></mat-icon>
        </div>
      </div>
      <div class="lv-drawer-content">
        <div class="lv-drawer-content-filter-items">
          <cdk-virtual-scroll-viewport itemSize="9" class="lv-drawer-content-filter-items-viewport">
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.INVESTMENTSTIL' | translate"
                                [tooltip]="'MODAL_DIALOG.FONDS.TOOLTIPS.INVESTMENTSTIL' | translate"></lv-label-tooltip>
              <mat-form-field class="lv-material-form-input" color="accent">
                <div class="lv-input-field">
                  <mat-select (ngModelChange)="changeInvestmentStil($event)" name="investmentstil"
                              [hideSingleSelectionIndicator]="true" [ngModel]="filterInvestmentstile" multiple>
                    <mat-option *ngFor="let investmentStil of investmentStile"
                                [value]="investmentStil"
                                class="lv-mat-option-multiline">
                      {{ investmentStil | aktiveFilter }}

                    </mat-option>
                  </mat-select>
                </div>
              </mat-form-field>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.ESG_EINSTUFUNG' | translate"
                                [tooltip]="'MODAL_DIALOG.FONDS.TOOLTIPS.ESG_EINSTUFUNG' | translate"></lv-label-tooltip>
              <mat-form-field class="lv-material-form-input" color="accent">
                <div class="lv-input-field">
                  <mat-select (ngModelChange)="changeEsgEinstufung($event)" name="esgEinstufung"
                              [hideSingleSelectionIndicator]="true" [ngModel]="filterEsgEinstufung" multiple>
                    <mat-option *ngFor="let esgEinstufung of esgEinstufungen"
                                [value]="esgEinstufung"
                                class="lv-mat-option-multiline">
                      {{ esgEinstufung | aktiveFilter }}
                    </mat-option>
                  </mat-select>
                </div>
              </mat-form-field>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.FONDSKATEGORIE' | translate"></lv-label-tooltip>
              <mat-form-field class="lv-material-form-input" color="accent">
                <div class="lv-input-field">
                  <mat-select (valueChange)="changeKategorie($event)" name="kategorie"
                              [hideSingleSelectionIndicator]="true" [ngModel]="filterFondskategorie" multiple>
                    <mat-option *ngFor="let kategorie of kategorien"
                                [value]="kategorie"
                                class="lv-mat-option-multiline">
                      {{ kategorie }}
                    </mat-option>
                  </mat-select>
                </div>
              </mat-form-field>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.REGION' | translate"></lv-label-tooltip>
              <mat-form-field class="lv-material-form-input" color="accent">
                <div class="lv-input-field">
                  <mat-select  [hideSingleSelectionIndicator]="true" name="region" (valueChange)="changeRegionen($event)"
                              [ngModel]="filterRegion" multiple>
                    <mat-option *ngFor="let region of regionen"
                                [value]="region"
                                class="lv-mat-option-multiline">
                      {{ region }}
                    </mat-option>
                  </mat-select>
                </div>
              </mat-form-field>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.THEMA' | translate"></lv-label-tooltip>
              <mat-form-field class="lv-material-form-input" color="accent">
                <div class="lv-input-field">
                  <mat-select (valueChange)="changeThemen($event)" name="thema"
                              [hideSingleSelectionIndicator]="true" [ngModel]="filterThema" multiple>
                    <mat-option *ngFor="let thema of themen"
                                [value]="thema"
                                class="lv-mat-option-multiline">
                      {{ thema }}
                    </mat-option>
                  </mat-select>
                </div>
              </mat-form-field>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.PAI_BERUECKSICHTIGUNG' | translate"
                                [tooltip]="'MODAL_DIALOG.FONDS.TOOLTIPS.PAI_BERUECKSICHTIGUNG' | translate"></lv-label-tooltip>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <mat-form-field class="lv-material-form-input" color="accent">
                <div class="lv-input-field">
                  <mat-select (valueChange)="changePAI($event)" name="thema"
                              [hideSingleSelectionIndicator]="true" [ngModel]="filterPAI" multiple>
                    <mat-option *ngFor="let pai of pais"
                                [value]="pai"
                                class="lv-mat-option-multiline">
                      {{ pai | aktiveFilter }}
                    </mat-option>
                  </mat-select>
                </div>
              </mat-form-field>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.MINDEST_ANTEIL_NACHHALTIGE_INVESTITIONEN' | translate"
                                [tooltip]="'MODAL_DIALOG.FONDS.TOOLTIPS.MINDEST_ANTEIL_NACHHALTIGE_INVESTITIONEN' | translate"></lv-label-tooltip>
              <div class="lv-material-form-input">
                <lv-material-form-input [unit]="'Prozent'"
                                        [placeholder]="'0-100'"
                                        (inputChange)="applyFilter ()"
                                        #inputmodel="ngModel"
                                        [outerErrors]="inputmodel?.errors"
                                        [(ngModel)]="filterSustainableInvestments"
                                        [autocomplete]="autocomplete"
                                        lvMinMaxValidator [maxValue]="100" [minValue]="0">
                </lv-material-form-input>
              </div>
            </div>
            <div class="lv-display-flex-col-filter-items">
              <lv-label-tooltip [label]="'MODAL_DIALOG.FONDS.LABEL.MINDEST_ANTEIL_OEKOLOGISCHE_INVESTITIONEN' | translate"
                                [tooltip]="'MODAL_DIALOG.FONDS.TOOLTIPS.MINDEST_ANTEIL_OEKOLOGISCHE_INVESTITIONEN' | translate"></lv-label-tooltip>
              <div class="lv-display-flex-col-filter-items lv-display-flex-col-filter-items-input">
                <lv-material-form-input [unit]="'Prozent'"
                                        [placeholder]="'0-100'"
                                        (inputChange)="applyFilter ()"
                                        #inputmodel2="ngModel"
                                        [outerErrors]="inputmodel2?.errors"
                                        [(ngModel)]="filterSustainableInvestmentsAligned"
                                        [autocomplete]="autocomplete"
                                        lvMinMaxValidator [maxValue]="100" [minValue]="0">
                </lv-material-form-input>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
        <div class="lv-drawer-content-button">
          <button class="lv-fonds-modaldialog-footer-button_primary" [disabled]="filterAnzahlAktuell === 0" mat-raised-button color="primary"
                  (click)="drawer.toggle()">{{ filterAnzahlAktuell }}
            Ergebnisse anzeigen
          </button>
        </div>
      </div>
    </ng-container>
  </mat-drawer>
  <form name="form" #f="ngForm">
    <div class="lv-fonds-modaldialog">
      <div class="lv-fonds-modaldialog-header">
        <div class="lv-dialog-header-title">
          Fondsauswahl
        </div>
        <div class="lv-dialog-header-close-icon">
          <mat-icon [svgIcon]="'Times'" (click)="closeDialog()"></mat-icon>
        </div>
      </div>
      <div class="lv-fonds-modaldialog-content">
        <div class="lv-fonds-modaldialog-suche-filter">
          <div class="lv-display-flex-col-filter-items">
            <lv-material-form-input [placeholder]="'MODAL_DIALOG.FONDS.LABEL.FONDSSUCHE_PLACEHOLDER' | translate" name="fondssuche"
                                    (inputChange)="onNewFilterName ()"
                                    #inputmodel="ngModel"
                                    [autocomplete]="autocomplete"
                                    [(ngModel)]="filterFondsname" [prefixIcon]="'Search'" [disabled]="nurGewaehlteFondsAnzeigen">
            </lv-material-form-input>
          </div>
          <div class="lv-fonds-modaldialog-filter-button">
            <button mat-raised-button onclick="this.blur()" [disabled]="nurGewaehlteFondsAnzeigen$.value" (click)="drawer.toggle()">
              <mat-icon [svgIcon]="'Filter'"></mat-icon>
              <span class="lv-text-margin-left">Filter</span>
            </button>
          </div>
        </div>
        <div class="lv-fonds-modaldialog-aktive-filter-platzhalter" *ngIf="aktiveFilter.length === 0">
          &nbsp;
        </div>
        <div class="lv-fonds-modaldialog-aktive-filter" *ngIf="!!aktiveFilter.length">
          <mat-chip-listbox [disabled]="nurGewaehlteFondsAnzeigen$.value" #chipList aria-label="Aktive Filter">
            <button [disabled]="nurGewaehlteFondsAnzeigen$.value" style="border: none; background-color: white;"
                    (click)="deleteAllFilter()">
              <mat-chip-option color="primary" selected>
                Alle Filter löschen
                <button [disabled]="nurGewaehlteFondsAnzeigen$.value" matChipRemove (click)="deleteAllFilter()">
                  <mat-icon [svgIcon]="'CircleXmark'"></mat-icon>
                </button>
              </mat-chip-option>
            </button>
            <button [disabled]="nurGewaehlteFondsAnzeigen$.value" style="border: none; background-color: white;"
                    *ngFor="let aktiverFilter of aktiveFilter; index as i" (click)="deleteFilter(i)">
              <mat-chip-option color="accent" selected>
                {{ aktiverFilter.field }}: {{ aktiverFilter.value | aktiveFilter }}
                <button [disabled]="nurGewaehlteFondsAnzeigen$.value" matChipRemove (click)="deleteFilter(i)">
                  <mat-icon [svgIcon]="'Xmark'"></mat-icon>
                </button>
              </mat-chip-option>
            </button>
          </mat-chip-listbox>
        </div>

        <ng-container *ngIf="fondsData$ | async as selectedFonds">
          <mat-dialog-content>
            <ng-container *ngIf="nurGewaehlteFondsAnzeigen">
              <div class="lv-fonds-modaldialog-gewaehlte-fonds-anzahl">Gewählte Fonds</div>
            </ng-container>
            <ng-container *ngIf="!nurGewaehlteFondsAnzeigen">
              <ng-container *ngIf="!aktiveFilter.length && !filterFondsname">
                <div class="lv-fonds-modaldialog-gewaehlte-fonds-anzahl">{{ filterAnzahlGesamt }} Fonds</div>
              </ng-container>
              <ng-container *ngIf="!!(aktiveFilter.length) || (filternamenSubject | async)">
                <div class="lv-fonds-modaldialog-gewaehlte-fonds-anzahl">{{ filterAnzahlAktuell }} Fonds (von {{ filterAnzahlGesamt }})
                </div>
              </ng-container>
            </ng-container>
            <div class="lv-scrollable">
              <table class="lv-fonds-table lv-fonds-table-hover-row" mat-table [dataSource]="dataSource" matSort matSortActive="name"
                     matSortDirection="asc" matSortDisableClear>
                <ng-container matColumnDef="selected">
                  <th mat-header-cell class="lv-fonds-table-data-th-cell" *matHeaderCellDef>&nbsp;</th>
                  <td mat-cell class="lv-fonds-table-data-cell-first lv-fonds-table-data-cell-hover" *matCellDef="let element"
                      (click)="selectFonds(element.fondsId)">
                    <div class="element-hidden-on-small-screens">
                    <ng-container *ngIf="selectedFonds.includes(element.fondsId)">
                      <mat-checkbox [checked]="true"></mat-checkbox>
                    </ng-container>
                    <ng-container *ngIf="!selectedFonds.includes(element.fondsId)">
                      <mat-checkbox></mat-checkbox>
                    </ng-container>
                  </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell lv-fonds-table-cell-width-400">
                    Fondsname / ISIN
                  </th>
                  <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-data-cell-hover"
                      (click)="selectFonds(element.fondsId)">
                    <div class="element-visible-on-small-screens">
                    <ng-container  *ngIf="selectedFonds.includes(element.fondsId)">
                      <mat-checkbox [checked]="true"></mat-checkbox>
                    </ng-container>
                    <ng-container  *ngIf="!selectedFonds.includes(element.fondsId)">
                      <mat-checkbox></mat-checkbox>
                    </ng-container>
                    </div>
                    <ng-container>
                      <div class="bold-when-mobile" [innerHTML]="element.name | highlight: inputmodel.value"></div>
                      <div class="bold-when-mobile" [innerHTML]="element.isin | highlight: inputmodel.value"></div>
                    </ng-container>
                  </td>
                </ng-container>
                <ng-container matColumnDef="risikoklasse">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell">SRI</th>
                  <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell has_label_on_mobile" data-label='SRI '>{{ element.risikoklasse }}</td>
                </ng-container>
                <ng-container matColumnDef="esgEinstufungTVO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lv-fonds-table-data-th-cell">ESG</th>
                  <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell has_label_on_mobile" data-label='ESG ' (click)="selectFonds(element.fondsId)">
                    Artikel {{ element.esgEinstufungTVO }}</td>
                </ng-container>
                <ng-container matColumnDef="factsheet">
                  <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">Factsheet</th>
                  <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-icon has_label_on_mobile" data-label='Factsheet '>
                    <a href="{{getLink('Factsheet', element.fondsId)}}" target="_blank">
                      <mat-icon [svgIcon]="'DownloadToLine'"></mat-icon>
                    </a></td>
                </ng-container>
                <ng-container matColumnDef="esgreport">
                  <th mat-header-cell *matHeaderCellDef class="lv-fonds-table-data-th-cell lv-fonds-table-icon">ESG-Report</th>
                  <td mat-cell *matCellDef="let element" class="lv-fonds-table-data-cell lv-fonds-table-icon has_label_on_mobile" data-label='ESG-Report '><a
                      href="{{getLink('ESG-Report', element.fondsId)}}" target="_blank">
                    <mat-icon [svgIcon]="'DownloadToLine'"></mat-icon>
                  </a></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns, sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </mat-dialog-content>
        </ng-container>
        <mat-divider></mat-divider>
      </div>

      <div class="lv-fonds-modaldialog-footer">
        <div class="lv-fonds-modaldialog-gewaehlte-fonds-anzahl">
          <div>{{ selectedFonds.length }} Fonds gewählt</div>
          <ng-container *ngIf="selectedFonds.length > 20">
            <lv-inline-fehlermeldung translationKeyFehlermmeldung="ERRORS.GESAMTPORTFOLIO_MAX_ZWANZIG_FONDS"></lv-inline-fehlermeldung>
          </ng-container>
          <ng-container *ngIf="selectedFonds.length <= 20">
            <div class="lv-fonds-modaldialog-gewaehlte-fonds-platzhalter">
              &nbsp;
            </div>
          </ng-container>
        </div>
        <div class="lv-fonds-modaldialog-footer-action">
          <div>
            <mat-slide-toggle (change)="changeToggle($event)">
              nur gewählte Fonds anzeigen
            </mat-slide-toggle>
          </div>
          <div class="lv-fonds-modaldialog-footer-buttons">
            <button mat-raised-button color="accent" class="lv-fonds-modaldialog-footer-button" (click)="closeDialog()">
              Abbrechen
            </button>
            <button mat-raised-button class="lv-fonds-modaldialog-footer-button_primary" color="primary"
                    [disabled]="selectedFonds.length > 20"
                    (click)="fondsUebernehmen()">
              Fonds übernehmen
            </button>
          </div>
        </div>
        <div style="height: 5px"></div>
      </div>
    </div>
  </form>
</mat-drawer-container>
